import { makeAutoObservable, reaction, runInAction } from 'mobx';

import { queryAPI } from '@cutwise/utils';

export class AppStore {
  isScrollLocked = false;

  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.isScrollLocked,
      (state: boolean) => {
        const root = document.getElementById('root');

        if (state) {
          root?.style.setProperty('overflow', 'hidden');
        } else {
          root?.style.removeProperty('overflow');
        }
      },
    );
  }

  setScrollLocked = (state: boolean) => {
    runInAction(() => {
      this.isScrollLocked = state;
    });
  };

  get isStarMetric() {
    return queryAPI.getKey('star') === '1';
  }
}

export const appStore = new AppStore();
